import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetRouteCheckIns, CreateRouteCheckIn } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const routeCheckInQueryKeys = {
  checkIns: (params?: Parameters<typeof GetRouteCheckIns>[0]) =>
    ["route-check-ins", params] as const,
};

export const invalidateRouteCheckInQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["route-check-ins"] });
};

export const useRouteCheckInsQuery = (
  params: Parameters<typeof GetRouteCheckIns>[0],
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: routeCheckInQueryKeys.checkIns(params),
    queryFn: async () => unwrapApiResponse(await GetRouteCheckIns(params)),
  });
};

export const useCreateRouteCheckInMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateRouteCheckIn>[0]) =>
      CreateRouteCheckIn(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateRouteCheckInQueries(queryClient);
      }
    },
  });
};
